import useAllStore from "@src/hooks/query/useAllStore";
import { ICartItem } from "@src/interface/Cart";
import { useAppSelector } from "@src/store/hooks";
import { useProductsSelector } from "../ProductSlice/selectors";
import { ECartStep } from "@src/components/page-content/Cart/ECartStep";

export type SelectedStore = ReturnType<typeof useSelectedStore>;

export const isValidCartStoreId = (
  idStore?: string | null
): idStore is string => !!idStore && idStore !== "0";

export const useCartQuantityOfProduct = (productId: string) => {
  const items = useCartItems();
  return {
    quantity: !!productId
      ? items.reduce<number>(
          (a, item) =>
            a + (item && item.id_product === productId ? item.quantity : 0),
          0
        )
      : 0,
  };
};

export const useCartItems = (): ICartItem[] => {
  const { currentCart } = useAppSelector(({ cart }) => cart);
  const { selectById } = useProductsSelector();
  const products = currentCart.products || [];

  return products.map((item) => {
    if (!item.id_product) return item;

    const productData = selectById(item.id_product);
    return {
      ...item,
      data: productData,
    };
  });
};

export const useCurrentCart = () =>
  useAppSelector(({ cart }) => cart.currentCart);

export const useOpenCurrentCart = (): boolean =>
  useAppSelector(({ cart }) => cart.open);
export const useCurrentCartStep = (): ECartStep =>
  useAppSelector(({ cart }) => cart.currentStep);

export const useSelectedStoreId = () => {
  const cart = useAppSelector(({ cart }) => cart.currentCart);
  return cart.id_store;
};

export const useSelectedStore = () => {
  const cart = useAppSelector(({ cart }) => cart.currentCart);
  const { data: stores } = useAllStore();
  if (isValidCartStoreId(cart.id_store)) {
    return stores.find(
      (store) => store.id_store && String(store.id_store) === String(cart.id_store)
    );
  }
  return null;
};

export const useCartStockoutProduct = () =>
  useAppSelector(({ cart }) => cart.stockoutProduct);
export const useCartModifiers = () =>
  useAppSelector(({ cart }) => cart.modifiers);
export const useIsLoadingCart = () =>
  useAppSelector(({ cart }) => cart.isLoadingCart);
export const useCartLoaded = () =>
  useAppSelector(({ cart }) => cart.cartLoaded);

export const useCartTotalItem = (): string =>
  useAppSelector(({ cart }) => cart.currentCart.total_piece || "");
